import { render, staticRenderFns } from "./UserEditPassword.vue?vue&type=template&id=51164a1a&"
import script from "./UserEditPassword.vue?vue&type=script&lang=js&"
export * from "./UserEditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports